export const advanceSearchConstants = {
  UPDATE_ADVANCE_SEARCH_QUERIES: 'UPDATE_ADVANCE_SEARCH_QUERIES',
  UPDATE_DEFAULT_QUERIES_ADVANCE_SEARCH: 'UPDATE_DEFAULT_QUERIES_ADVANCE_SEARCH',
  RESET_QUERIES_ADVANCE_SEARCH: 'RESET_QUERIES_ADVANCE_SEARCH',
  
  FETCH_ADVANCE_SEARCH_FILTERS_START: 'FETCH_ADVANCE_SEARCH_FILTERS_START',
  FETCH_ADVANCE_SEARCH_FILTERS_SUCCESS: 'FETCH_ADVANCE_SEARCH_FILTERS_SUCCESS',
  FETCH_ADVANCE_SEARCH_FILTERS_FAILURE: 'FETCH_ADVANCE_SEARCH_FILTERS_FAILURE',

  FETCH_ADVANCE_SEARCH_START: 'FETCH_ADVANCE_SEARCH_START',
  FETCH_ADVANCE_SEARCH_SUCCESS: 'FETCH_ADVANCE_SEARCH_SUCCESS',
  FETCH_ADVANCE_SEARCH_FAILURE: 'FETCH_ADVANCE_SEARCH_FAILURE',

  UPDATE_NAV_DATE_ADVANCE_SEARCH: 'UPDATE_NAV_DATE_ADVANCE_SEARCH',
  
  FETCH_NAV_ADVANCE_SEARCH_START: 'FETCH_NAV_ADVANCE_SEARCH_START',
  FETCH_NAV_ADVANCE_SEARCH_SUCCESS: 'FETCH_NAV_ADVANCE_SEARCH_SUCCESS',
  FETCH_NAV_ADVANCE_SEARCH_FAILURE: 'FETCH_NAV_ADVANCE_SEARCH_FAILURE',

  UPDATE_CURRENT_PAGE_SEARCH: 'UPDATE_CURRENT_PAGE_SEARCH',

  UPDATE_TABLE_COLUMN: 'UPDATE_TABLE_COLUMN'
};
